import { render, staticRenderFns } from "./formplain.vue?vue&type=template&id=17d6788c"
import script from "./formplain.vue?vue&type=script&lang=js"
export * from "./formplain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports